var $ = require('jquery');
var dispatcher = require('../dispatcher');

module.exports = function () {

	var preventAction = false;

	dispatcher.subscribe(dispatcher.events.DISABLE_KEYBOARD_CONTROLS, function () {
		preventAction = true;
	});

	dispatcher.subscribe(dispatcher.events.ENABLE_KEYBOARD_CONTROLS, function () {
		preventAction = false;
	});

	dispatcher.subscribe(dispatcher.events.DISABLE_CONTROLS, function () {
		preventAction = true;
	});

	dispatcher.subscribe(dispatcher.events.ENABLE_CONTROLS, function () {
		preventAction = false;
	});

	$(window).on('keydown', function (e) {
		var ctrlKey = e.ctrlKey || e.metaKey;
		var key = e.keyCode;
		var target = e.target.localName;
		var isBody = target === 'body';
	
		if (preventAction) return;

		if ((key === 114 || (ctrlKey && key === 70)) && isBody) { //CTRL + F
			e.preventDefault();

			$('input.search').focus();
		} else if (key === 32 && isBody) { //SPACE BAR
			e.preventDefault();

			dispatcher.emit(dispatcher.events.PLAY_VIDEO);
		} else if (key === 37 && isBody) { //LEFT ARROW
			e.preventDefault();

			dispatcher.emit(dispatcher.events.SKIP_BACKWARD_1);
		} else if (key === 39 && isBody) { //RIGHT ARROW
			e.preventDefault();

			dispatcher.emit(dispatcher.events.SKIP_FORWARD_1);
		} else if (key === 38 && isBody) { //UP ARROW
			e.preventDefault();
			dispatcher.emit(dispatcher.events.SCROLL_UP, -1);
		} else if (key === 33 && isBody) { //UP ARROW
			e.preventDefault();
			dispatcher.emit(dispatcher.events.SCROLL_UP, -6,true);
		} else if (key === 34 && isBody) { //UP ARROW
			e.preventDefault();
			dispatcher.emit(dispatcher.events.SCROLL_DOWN, +6,true);
		} else if (key === 40 && isBody) { //DOWN ARROW
			e.preventDefault();

			dispatcher.emit(dispatcher.events.SCROLL_DOWN, +1);
		} else if (key === 74 && isBody && ctrlKey) { //CTRL + J
			e.preventDefault();

			dispatcher.emit(dispatcher.events.JUMP_TO);
			dispatcher.emit(dispatcher.events.DISABLE_KEYBOARD_CONTROLS);
		} else if (key === 65 && isBody && ctrlKey) { //CTRL + A
			e.preventDefault();

			dispatcher.emit(dispatcher.events.ADD_SUBTITLE);
		} else if ((key === 8 || key === 46) && isBody && ctrlKey) { //CTRL+DELETE / CTRL+BACKSPACE
			e.preventDefault();

			dispatcher.emit(dispatcher.events.DELETE_SUBTITLE);
		} else if (key === 83 && isBody && ctrlKey) { //CTRL + S
			e.preventDefault();

			dispatcher.emit(dispatcher.events.SPLIT_SUBTITLE);
		} else if (key === 77 && isBody && ctrlKey) { //CTRL + M
			e.preventDefault();

			dispatcher.emit(dispatcher.events.MERGE_SUBTITLE);
		} else if (key === 90 && isBody && ctrlKey) { //CTRL + Z
			e.preventDefault();

			dispatcher.emit(dispatcher.events.UNDO_CHANGES);
		} else if (key === 73 && isBody && ctrlKey) { //CTRL + I
			e.preventDefault();

			dispatcher.emit(dispatcher.events.ITALIC);
		} else if (key === 89 && isBody && ctrlKey) { //CTRL + Y
			e.preventDefault();

			dispatcher.emit(dispatcher.events.REDO_CHANGES);
		} else if (key === 89 && isBody && ctrlKey) { //CTRL + U
			e.preventDefault();

			dispatcher.emit(dispatcher.events.SYNC);
		} else if (key === 66 && isBody && ctrlKey) { //CTRL + B
			e.preventDefault();

			dispatcher.emit(dispatcher.events.BLACK_BG);
		}
	});
};


// WEBPACK FOOTER //
// ./app/helpers/keystrokes-overwrite.js